import React, { useState } from "react";
import {Container, Row, Col, Button} from "react-bootstrap";
import { localStorage } from "window-or-global";
import Main from "../components/main";
import PortalHeader from "../components/portal/portal-header";
import Loader from "../components/bootstrap/loader";
import Notification from "../components/bootstrap/notification";
import PlanInfromation from "../controls/portal/plan-information";
import Usage from "../controls/portal/usage";
import UserDetails from "../controls/portal/user-details";
import AccountDetails from "../controls/portal/account-details";
import ConnectedDevices from "../controls/portal/connected-devices";
import {getCurrentUserQuery} from "../components/logic/user";
import AcceptTNC from "../components/bootstrap/tnc";
import useUnload from "../components/logic/useUnload";
import DeviceItem from "../components/portal/device/device-item";
import AddDevice from "../components/portal/device/add-device";
import config from "../config";
import {UserCheck, Banners, useNetworkAuthStore, PortalCurrentDevice} from "@superloop-bnsc/react-portal";

export default function Portal() {
  return (
    <Main>
      <PortalHeader />
      <PortalIndex />
    </Main>
  );
}


const PortalIndex = (props) => {
  return (
    <UserCheck isPortal Loader={Loader} getCurrentUserQuery={getCurrentUserQuery} portal="/portal/" LoginPage={PortalAccount} endpoint={config.authEndpoint} getCurrentUserResult={(result) => result?.data?.classMethods?.User?.getCurrentUser} />
  );
};

function PortalAccount({user}) {
  // console.log({ user })
  const [showAddDevice, setAddDevice] = useState(false);
  const currentMacAddress = useNetworkAuthStore((state) => state.macAddress);

  useUnload(e=>{
    const isPersist = localStorage.getItem("keepUserLogged");
    if (isPersist === "false" && !user) {
      localStorage.removeItem("authToken");
    }
  });

  if(!user) {
    return (<React.Fragment/>)
  }


  return (
    <div className="portal-page">
      <Banners currentUser={user} isPortal portalUrl={config.portal} externalUrl={config.externalUrl} />
      {showAddDevice && <AddDevice show user={user} onClose={() => setAddDevice(false)} defaultMacAddress={showAddDevice === "current" ? currentMacAddress : ""}/> }
      {(user.requireAcceptTNC || user.requireChangePassword) && (<AcceptTNC user={user} />)}
      <Container>
        <div>
          <Notification
            overLimit={user.overLimit}
            disabled={user.disabled}
            activeOrders={user.activeOrders}
          />
        </div>
        <Row>
          <Col className="vw-portal-account-title">
            {`Welcome ${user.firstName} ${user.lastName}!`}
          </Col>
        </Row>
        <Row>
          <PlanInfromation
            user={user}
          />
          <Usage user={user} />
        </Row>
        <Row>
          <UserDetails user={user} />
          <AccountDetails user={user} />
          <ConnectedDevices user={user} />
        </Row>
        <div className="current-device-info-section">
          <PortalCurrentDevice />     
        </div>
        <Row className="pb-5">
          <Col xs={12}>
            <section className="panel-container devices-section">
              <div className="panel-header">
                <div className="header-section-1">
                  <p className="header-title">{`Devices ${user.deviceLimit ? `- ${user.devices.edges.length}/${user.deviceLimit}` : ""}`}</p>
                </div>

                <div className="header-section-2">
                {(currentMacAddress && currentMacAddress !== "") && (
                    <Button
                      onClick={async () => setAddDevice("current")}
                      className="add-current-device-button"
                    >
                      <img 
                          src="https://cdn.vostro.app/cdn/hotspots/base/icon_add current device.svg"
                          className="add-current-icon"
                      />  
                        {"Add Current Device"}
                </Button>)}
                <Button
                  onClick={() => setAddDevice(true)}
                  className="add-device-button"
                  variant="black-text"
                >
                  <i className="fal fa-plus"/> Add Device
                </Button>
                </div>
              </div>
              <div className="device-list-container">
                {user?.devices?.edges?.map(device => {
                  return <DeviceItem device={device.node}/>
                })}
              </div>
              {user?.devices?.edges?.length === 0 && (
                <div className="no-devices">
                  <i className="fal fa-inbox"/>
                  No data available
                </div>
              )}
            </section>
          </Col>
        </Row>
      </Container>
    </div>
  );
}
